import { UploadFileStep } from "./types";

export const MAX_UPLOAD_STEPS = Object.keys(UploadFileStep).length / 2;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const DEFAULT_UPLOAD_MAX_FILE_SIZE = 50 * 1024 * 1024;
